import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Col, Row, Button } from 'reactstrap';
import HolidayTable from './HolidayTable';
import { addHoliday, getHolidays } from 'store/actions';
import CreateHoliday from './CreateHoliday';
import Breadcrumb from 'components/Common/Breadcrumb2';

const HolidayList = () => {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();

    const dispatch = useDispatch();
    const holidays = useSelector((state) => state.Holidays.holidays);
    const loading = useSelector((state) => state.Holidays.loading);
    const error = useSelector((state) => state.Holidays.error);

    const permissions = JSON.parse(localStorage?.getItem('permissions'));

    // Dispatch action to fetch holidays when the component mounts
    useEffect(() => {
        if (loading) return;
        dispatch(getHolidays()); // Dispatch the action to fetch holidays
    }, [dispatch]);

    const handleSubmit = (data) => {
        dispatch(addHoliday(data));
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    return (
        <>
            <CreateHoliday visible={isOpen} onSubmit={handleSubmit} handleClose={handleClose} />
            <div className="page-content container-fluid">
                <div className="d-flex justify-content-between align-items-center mx-3 ">
                    <Breadcrumb
                        title="Holidays"
                        breadcrumbItems={[
                            { title: "Dashboard", link: `/dashboard` },
                            { title: "Holidays", link: '#' },
                        ]}
                    />
                    {permissions?.map(item => item?.permissionName)?.includes("Add Holidays") && <Button
                        className="bg-primary text-white d-flex justify-content-center gap-1 align-items-center"
                        onClick={() => setIsOpen(true)}
                    >
                        <i className="ti-plus"></i> Add New
                    </Button>}
                </div>

                <HolidayTable loading={loading} List={holidays?.Data} />
            </div>
        </>
    );
};

export default HolidayList;
